/* eslint-disable prettier/prettier */
export const fetchIndicators = resp => {
    return {
      type: "FETCH_INDICATORS_LIST",
      payload: resp
    };
  };

export const fetchSupportedIndicatorVars = resp => {
    return {
        type: "FETCH_SUPPORTED_INIDCATOR_VARS",
        payload: resp
    }
}

export const updateIndicator = resp => {
    return {
        type: "UPDATE_INDICATOR",
        payload: resp
    }
}

export const defineIndicator = resp => {
    return {
        type: "DEFINE_INDICATOR",
        payload: resp
    }
}

export const deleteIndicator = resp => {
    return {
        type: "DELETE_INDICATOR",
        payload: resp
    }
}



// WEBPACK FOOTER //
// ./src/actions/actions/indicator.js